import { onMounted, onUnmounted, ref } from 'vue'

// 폰 레이아웃(하단 탭 셸)을 쓸지 결정한다. Capacitor 웹뷰는 폰 폭이라 자동으로 모바일.
// 데스크톱 브라우저를 좁혀도 모바일 셸로 전환된다(디자인 확인·반응형).
const MOBILE = '(max-width: 760px)'

export function useIsMobile() {
  const isMobile = ref(false)
  let mq: MediaQueryList | null = null
  const update = () => { isMobile.value = mq!.matches }
  onMounted(() => {
    mq = matchMedia(MOBILE)
    update()
    mq.addEventListener('change', update)
  })
  onUnmounted(() => mq?.removeEventListener('change', update))
  return { isMobile }
}
